/*
 * @flow
 *
 * These sagas are split from the reducer and actions to prevent webpack from
 * loading every single slice and the Prismic library into the main bundle when
 * creating the root reducer
 */
import { type Saga } from "redux-saga";
import { type Match } from "react-router";
import { all, select, call, put, getContext } from "redux-saga/effects";
import { PrismicResourceNotFound } from "../../utils/PrismicClient/PrismicClient";
import { setNavigationColour } from "../MarketingLayout/Navigation/ducks";
import { getSliceComponent } from "./Slice";
import { getPageSuccess, pageNotFound, getPageError } from "./ducks";

const selectPage = ({ customPages }, id) => customPages[id];

export function* fetchCustomPageSaga({
  params: { item },
}: Match<{ item: ?string }>): Saga<void> {
  const id = item || "default";
  const page = yield select(selectPage, id);
  if (page?.fetched) {
    return;
  }

  try {
    const prismicClient = yield getContext("prismicClient");
    const result = yield call(prismicClient.getPage, id);
    yield put(getPageSuccess(id, result));
    yield put(setNavigationColour(result.data.body[0]?.primary?.colour));
    yield all(result.data.body.map((slice) => call(fetchSliceData, slice)));
  } catch (e) {
    if (
      e instanceof PrismicResourceNotFound ||
      e.message === "Page not found" ||
      e.status === 404
    ) {
      yield put(pageNotFound(id));
    } else {
      yield put(getPageError(id, e));
    }
  }
}

export function* fetchSliceData(slice: PrismicSlice): Saga<void> {
  const universalSliceComponent = yield call(getSliceComponent, slice);
  const sliceComponent = yield call(universalSliceComponent.preload);
  const fetchFunction = sliceComponent?.fetchData;
  if (fetchFunction) {
    yield call(fetchFunction);
  }
}
